/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'tmo-star-rating',
  templateUrl: './star-rating.component.html',
})
export class StarRatingComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * Input value for error object .
   */
  @Input() public center: boolean;
  /**
   * Input value for error object .
   */
  @Input() public rating: number;

  /**
   * Input value for error object .
   */
  @Input() public showMiniStar: boolean;

  /**
   * Input value for error object .
   */
  @Input() public showMediumStar: boolean;

  /**
   * Input value for error object .
   */
  @Input() public showMegaStar: boolean;

  /**
   * To get full star count
   */
  public fullStarCount: number[];

  /**
   * To get empty star count
   */
  public emptyStarCount: number[];

  /**
   * Subject to manage subscriptions
   */
  private ngUnsubscribe: Subject<void>;

  public width: number;

  public totalWidth: number;
  public totalHeight: number;

  constructor() {
    this.ngUnsubscribe = new Subject<void>();
  }

  public ngOnInit(): void {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      const mediumWidth = 111;
      const MegaWidth = 176;
      const mediumHeight = 18;
      const megaHeight = 32;
      if (this.showMediumStar) {
        this.totalWidth = mediumWidth;
        this.totalHeight = mediumHeight;
      }
      if (this.showMegaStar) {
        this.totalWidth = MegaWidth;
        this.totalHeight = megaHeight;
      }
      const starsCount = 5;
      this.fullStarCount = Array(starsCount);
      const percentVal = 100;
      this.width = (this.rating / starsCount) * percentVal;
    }, 0);
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
